'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const useResizeObserver = () => {
  const ref = React.useRef(null);
  const [width, setWidth] = React.useState(0);
  const [height, setHeight] = React.useState(0);
  React.useEffect(() => {
    const node = ref.current;
    let observer;
    try {
      observer = new ResizeObserver((entries) => {
        const lastEntry = entries.pop();
        if (lastEntry) {
          const contentRect = Array.isArray(lastEntry.contentRect) ? lastEntry.contentRect[0] : lastEntry.contentRect;
          setWidth(contentRect.width);
          setHeight(contentRect.height);
        }
      });
      observer.observe(node);
    } catch (e) {
    }
    return () => {
      observer === null || observer === void 0 ? void 0 : observer.disconnect();
    };
  });
  return {
    ref,
    width,
    height
  };
};

exports.useResizeObserver = useResizeObserver;
//# sourceMappingURL=useResizeObserver.cjs.js.map
